import * as yup from 'yup';
import _ from 'lodash';

import { SanificationConf } from './common/Sanification.conf';
import { CashDeclarationConf } from './common/CashDeclaration.conf';
import { CentralAgentServiceConf } from './common/CentralAgentService.conf';
import { ArrivalDepartureConf } from './common/ArrivalDeparture.conf';
import { PilotiINConf } from './common/PilotIN.conf';
import { ImmigrationFormalitiesConf } from './common/Immigration.conf';
import { GarbageConf } from './common/Garbage.conf';
import { GenericConf } from './common/Generic.conf';
import { PilotiOUTConf } from './common/PilotOUT.conf';
import { BerthBuoyConf } from './common/BerthBuoy.conf';
import { ServiceConf } from './common/Service.conf';
import { BerthConf } from './common/Berth.conf';
import { BuoyConf } from './common/Buoy.conf';
import {
  OpCustomStatusBookingConf,
  OperationCustomConf,
} from './common/OperationCustom.conf';
import { BunkerConf } from './common/Bunker.conf';
import { ParkPermitConf } from '../../concierge/conf/common/ParkPermit.conf';
import { OperationConf as Operation } from '../../operations/conf/Create.conf';
import { ServiceParkPermitConf } from './common/ServiceParkPermit.conf';
import { AtAnchorBookedDirectlyConf } from './common/AtAnchorBookedDirectly.conf';
import { StatusDefault as StatusBooking } from '../../booking/conf/Data.conf';

const OperationConf = {
  schema: _.omit(Operation.schema, 'requested_date', 'id_marina'),
  defaultValues: {
    ..._.omit(Operation.defaultValues, 'requested_date', 'id_marina'),
    id_item: null,
  },
  fields: _.concat(
    Operation.fields.slice(0, 1),
    Operation.fields.slice(2, 4),
    Operation.fields.slice(5)
  ),
};

export const UpdateConf = {
  'ARRIVAL & DEPARTURE FORMALITIES': {
    schema: yup.object({
      ...ArrivalDepartureConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...ArrivalDepartureConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      ArrivalDepartureConf.fields,
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2)
    ),
  },
  'IMMIGRATION FORMALITIES': {
    schema: yup.object({
      ...ImmigrationFormalitiesConf.schema,
      ...ServiceConf.schema,

      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...ImmigrationFormalitiesConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      ImmigrationFormalitiesConf.fields.slice(0, 2),
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      ImmigrationFormalitiesConf.fields.slice(2),
      OperationCustomConf.fields.slice(3)
    ),
  },
  'GARBAGE DISPOSAL': {
    schema: yup.object({
      ...GarbageConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...GarbageConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      GarbageConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      GarbageConf.fields.slice(1),
      OperationCustomConf.fields.slice(3)
    ),
  },
  'PILOTS IN': {
    schema: yup.object({
      ...PilotiINConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...PilotiINConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      PilotiINConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      PilotiINConf.fields.slice(1),
      OperationCustomConf.fields.slice(3)
    ),
  },

  'PILOTS OUT': {
    schema: yup.object({
      ...PilotiOUTConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...PilotiOUTConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      PilotiOUTConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      PilotiOUTConf.fields.slice(1),
      OperationCustomConf.fields.slice(3)
    ),
  },
  'BERTH RESERVATION': {
    schema: yup.object({
      ...BerthBuoyConf.schema,
      ...BerthConf.schema,
      ..._.omit(ServiceConf.schema, 'service_date'),
      ..._.omit(OperationCustomConf.schema, 'check_out_date'),
    }),
    defaultValues: {
      ...BerthBuoyConf.defaultValues,
      ...BerthConf.defaultValues,
      ..._.omit(ServiceConf.defaultValues, 'service_date'),
      ..._.omit(OperationCustomConf.defaultValues, 'check_out_date'),
    },
    fields: _.concat(
      BerthBuoyConf.fields.slice(0, 1),
      BerthConf.fields,
      ServiceConf.fields.slice(0, 1),
      BerthBuoyConf.fields.slice(1, 6),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(1, 2),
      BerthBuoyConf.fields.slice(6),
      OperationCustomConf.fields.slice(3)
    ),
  },

  'BUOY RESERVATION': {
    schema: yup.object({
      ...BerthBuoyConf.schema,
      ...BuoyConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
      //      ..._.omit(OperationCustomConf.schema, 'check_out_date'),

    }),
    defaultValues: {
      ...BerthBuoyConf.defaultValues,
      ...BuoyConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
      //      ..._.omit(OperationCustomConf.defaultValues, 'check_out_date'),

    },
    fields: _.concat(
      BerthBuoyConf.fields.slice(0, 1),
      BuoyConf.fields,
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(1, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      BerthBuoyConf.fields.slice(1),
      OperationCustomConf.fields.slice(3)
    ),
  },
  'GENERIC SERVICE': {
    schema: yup.object({
      ...GenericConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...GenericConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      GenericConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      GenericConf.fields.slice(1),
      OperationCustomConf.fields.slice(3)
    ),
  },
  'CASH DECLARATION': {
    schema: yup.object({
      ...CashDeclarationConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...CashDeclarationConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      CashDeclarationConf.fields,
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2)
    ),
  },
  'SANITATION FORMALITIES': {
    schema: yup.object({
      ...SanificationConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...SanificationConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      SanificationConf.fields,
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2)
    ),
  },
  BUNKER: {
    schema: yup.object({
      ...ServiceConf.schema,
      ...BunkerConf.schema,
    }),
    defaultValues: {
      ...ServiceConf.defaultValues,
      ...BunkerConf.defaultValues,
    },
    fields: _.concat(
      GenericConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 2),
      BunkerConf.fields.slice(0, 1),
      ServiceConf.fields.slice(2, 3),
      BunkerConf.fields.slice(1)
    ),
  },
  'PARK PERMIT': {
    schema: yup.object({
      ...ServiceParkPermitConf.schema,
      ..._.pick(ServiceConf.schema, ['id_item']),
      ...ParkPermitConf.schema,
      ...OperationConf.schema,
    }),
    defaultValues: {
      ...ServiceParkPermitConf.defaultValues,
      ..._.pick(ServiceConf.defaultValues, ['id_item']),
      ...ParkPermitConf.defaultValues,
      ...OperationConf.defaultValues,
    },
    fields: _.concat(
      ServiceParkPermitConf.fields,
      ParkPermitConf.fields.slice(0, -1),
      ServiceConf.fields.slice(2, 3),
      ParkPermitConf.fields.slice(-1),
      OperationConf.fields
    ),
  },
  'CENTRAL AGENT': {
    schema: yup.object({
      ...GenericConf.schema,
      ...CentralAgentServiceConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...GenericConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      GenericConf.fields.slice(0, 1),
      CentralAgentServiceConf.fields,
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      GenericConf.fields.slice(1),
      OperationCustomConf.fields.slice(3)
    ),
  },
  DIVERS: {
    schema: yup.object({
      ...GenericConf.schema,
      ...ServiceConf.schema,
      ...OperationCustomConf.schema,
    }),
    defaultValues: {
      ...GenericConf.defaultValues,
      ...ServiceConf.defaultValues,
      ...OperationCustomConf.defaultValues,
    },
    fields: _.concat(
      GenericConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 2),
      OperationCustomConf.fields.slice(0, 2),
      ServiceConf.fields.slice(2, 3),
      OperationCustomConf.fields.slice(2, 3),
      GenericConf.fields.slice(1),
      OperationCustomConf.fields.slice(3)
    ),
  },
  'AT ANCHOR': {
    schema: yup.object({
      ...AtAnchorBookedDirectlyConf.schema,
      ..._.omit(ServiceConf.schema, 'service_date'),
      ...OpCustomStatusBookingConf.schema,
      //      ..._.omit(OpCustomStatusBookingConf.schema, 'check_out_date'),

    }),
    defaultValues: {
      ...AtAnchorBookedDirectlyConf.defaultValues,
      ..._.omit(ServiceConf.defaultValues, 'service_date'),
      ...OpCustomStatusBookingConf.defaultValues,
      status_operation_booking: _.find(StatusBooking, {
        label: 'AT ANCHOR',
      }).id,
      //      ..._.omit(OpCustomStatusBookingConf.defaultValues, 'check_out_date'),

    },
    fields: _.concat(
      AtAnchorBookedDirectlyConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 1),
      AtAnchorBookedDirectlyConf.fields.slice(1, 6),
      ServiceConf.fields.slice(2, 3),
      OpCustomStatusBookingConf.fields.slice(2, 3),
      OpCustomStatusBookingConf.fields.slice(1, 2),
      AtAnchorBookedDirectlyConf.fields.slice(6),
      OpCustomStatusBookingConf.fields.slice(3)
    ),
  },
  'BOOKED DIRECTLY': {
    schema: yup.object({
      ...AtAnchorBookedDirectlyConf.schema,
      ..._.omit(ServiceConf.schema, 'service_date'),
      ...OpCustomStatusBookingConf.schema,
      //      ..._.omit(OpCustomStatusBookingConf.schema, 'check_out_date'),

    }),
    defaultValues: {
      ...AtAnchorBookedDirectlyConf.defaultValues,
      ..._.omit(ServiceConf.defaultValues, 'service_date'),
      ...OpCustomStatusBookingConf.defaultValues,
      status_operation_booking: _.find(StatusBooking, {
        label: 'BOOKED DIRECTLY',
      }).id,
      //..._.omit(OpCustomStatusBookingConf.defaultValues, 'check_out_date'),

    },
    fields: _.concat(
      AtAnchorBookedDirectlyConf.fields.slice(0, 1),
      ServiceConf.fields.slice(0, 1),
      AtAnchorBookedDirectlyConf.fields.slice(1, 6),
      ServiceConf.fields.slice(2, 3),
      OpCustomStatusBookingConf.fields.slice(2, 3),
      OpCustomStatusBookingConf.fields.slice(1, 2),
      AtAnchorBookedDirectlyConf.fields.slice(6),
      OpCustomStatusBookingConf.fields.slice(3)
    ),
  },
};
